// extracted by mini-css-extract-plugin
module.exports = {"page":"QQ-z","cartModal":"RQ-z","checkout":"SQ-z","placeholder":"TQ-z","account":"UQ-z"};